// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"hO-z","carouselContainer":"iO-z"};